import { curry } from 'lib/util'
import tankValues from '@model/xEcoApm/collection/tank'

/**
 * Returns the list of available tank values.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 * @returns the list of frequencies
 */
const listTankValues = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
): { key: number, value: string }[] => tankValues

export default curry(listTankValues)
